import { useCustomTheme, useThemeMode } from "pixelize-design-library";

export const useAppTheme = () => {
  const theme = useCustomTheme();
  const { resolvedMode } = useThemeMode();

  return { theme, colors: theme.colors, resolvedMode } as const;
};
